import { render } from "./SelecionarTransportadora.vue?vue&type=template&id=11346743&scoped=true&ts=true"
import script from "./SelecionarTransportadora.vue?vue&type=script&lang=ts"
export * from "./SelecionarTransportadora.vue?vue&type=script&lang=ts"

import "./SelecionarTransportadora.vue?vue&type=style&index=0&id=11346743&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11346743"]])

export default __exports__